<script>
	import { capitalize, separateSnakeCase } from "src/utils/misc";

	export let row;
	export let key;
	export let event;
	export let action;
	export let options;
	export let index;
</script>

{#if row.action === "Door_Lock" || row.action === "Door_Unlock"}
	<div>
		<span>
			<b>
				{row.createdBy}
				{row.action === "Door_Lock" ? "locked" : "unlocked"} this car
			</b>
		</span>
	</div>
	<br />
	<div>
		<span>
			<b>Reason:</b>
		</span>
	</div>
	<div>
		<span>
			{row.remark}
		</span>
	</div>
{:else if row.action === "Update"}
	<span>
		<b>
			{row.createdBy}
			changed {capitalize(separateSnakeCase(row.field))} from {row.before}
			to {row.after}
		</b>
	</span>
{:else}
	<span>
		<b>
			{row.createdBy} created {row.after}
		</b>
	</span>
{/if}
